module.exports = __webpack_public_path__ + "static/media/stop.40efdd8c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/stop.svg
// module id = 23
// module chunks = 1